import React from "react";
import StopCovid from "@page-contents/stop-covid";

export default () => <StopCovid />;
